































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import appconst from '@/lib/appconst';
import Enums from '@/lib/enums'
class AddBaseCost {
    userCode: string;
    costPoints: number;
    orderType: number;
    isEnable: boolean;
    storeId?: number;
    id: number;
}
@Component
export default class EditUserStorageConfig extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    freight: AddBaseCost = new AddBaseCost();
    addLoding = false;
    amountTotal: string = '';
    created() {
    }
    signFor() {
        this.save();
    }
    save() {
        (this.$refs.freightCreateForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.addLoding = true;
                this.freight.orderType = 0;
                this.freight.storeId = null;

                await this.$store.dispatch({
                    type: 'backuserstorageconfigSetting/edit',
                    data: this.freight
                }).finally(() => {
                    this.addLoding = false;
                });
                (this.$refs.freightCreateForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input', false);
            }
        })
    }

    cancel() {
        (this.$refs.freightCreateForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
            var data = this.$store.state.backuserstorageconfigSetting.updateOrdeData;
            this.freight.id = data.id;
            this.freight.isEnable = data.isEnable;
            this.freight.orderType = data.orderType;
            this.freight.storeId = data.storeId;
            this.freight.userCode = data.userCode;
            this.freight.costPoints = data.costPoints;
        }
    }
    freightRule = {
        userCode: [{ required: true, message: "用户编号不能为空", trigger: 'blur' }],
        costPoints: [{ required: true, message: '费用不能为空（按积分计算）', trigger: 'blur' }],
    };

}
